module.exports = __webpack_public_path__ + "static/media/Endurance_Blue.464626f0.png";